import { getCurrentBrand } from '../config/api';

const LEMON8_ENABLED_BRANDS = new Set(['connectai', 'ashley']);
const LIMITED_BACKOFFICE_BRANDS = new Set([
  'zeekr',
  'motorrad',
  'mini',
  'ford',
  'mitsubishi',
  'byd',
  'denza',
  'icaur',
  'bmw'
]);

const MEMBERS_ENABLED_BRANDS = new Set(['connectai', ...LIMITED_BACKOFFICE_BRANDS]);

export function isLemon8Enabled(brand = getCurrentBrand()) {
  return LEMON8_ENABLED_BRANDS.has(String(brand || '').toLowerCase());
}

export function hasLimitedBackofficeNavigation(brand = getCurrentBrand()) {
  const brandTokens = String(brand || '')
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(Boolean);

  return brandTokens.some(token => LIMITED_BACKOFFICE_BRANDS.has(token));
}

export function isMembersEnabled(brand = getCurrentBrand()) {
  const brandTokens = String(brand || '')
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(Boolean);

  return brandTokens.some(token => MEMBERS_ENABLED_BRANDS.has(token));
}

/** XHS AI Image Generator (Replicate) */
export function isXhsAiImageEnabled() {
  return true;
}
